import { useEffect, useState } from 'preact/hooks';

import {
  resubscribe as resubscribeApi,
  unsubscribe as unsubscribeApi,
} from 'fetchers/subscription.fetchers';
import type Shipment from 'interfaces/PmParcel';
import { getSubscriptionParams } from 'services/globalConfig.services';
import { useSearchParams } from 'hooks/useSearchParams';

export const useSubscription = (
  organizationId: number,
  selectedShipment: Shipment,
) => {
  const { removeSearchParams } = useSearchParams();

  const [showSubscriptionModal, setShowSubscriptionModal] = useState(false);
  const [isResubscribing, setIsResubscribing] = useState(false);
  const [isResubscribedFail, setIsResubscribedFail] = useState(false);

  const { isUnsubscribe, mediumType, handler } = getSubscriptionParams();

  const handleResubscribe = async () => {
    setIsResubscribedFail(false);
    setIsResubscribing(true);
    try {
      await resubscribeApi(
        selectedShipment.id,
        organizationId,
        mediumType,
        handler,
      );

      setShowSubscriptionModal(false);

      removeSearchParams(
        ['organization_id', 'pp_unsubscribe', 'medium_type', 'handler'],
        { replace: true },
      );
    } catch (err) {
      setIsResubscribedFail(true);
    } finally {
      setIsResubscribing(false);
    }
  };

  const handleCloseSubscriptionModal = () => {
    setShowSubscriptionModal(false);
  };

  useEffect(() => {
    if (!isUnsubscribe || !selectedShipment) return;

    const handleUnsubscribe = async () => {
      try {
        await unsubscribeApi(selectedShipment.id, mediumType, handler);
        setShowSubscriptionModal(true);
      } catch (error) {
        console.warn('unsubscribe error', error);
      }
    };

    handleUnsubscribe();
  }, [selectedShipment]);

  return {
    isResubscribing,
    isResubscribedFail,
    showSubscriptionModal,
    handleCloseSubscriptionModal,
    handleResubscribe,
  };
};
